import Vue from "vue";
import moment from "moment";

Vue.filter("myDate", function(date) {
  moment.locale("es");
  return moment(date).format("MMMM Do YYYY");
});
